import * as R from "ramda";
import { GroupColumn } from "common/form/types";
import { merge1 } from "common/merge";

const disableColumn = (c: GroupColumn) => merge1("disabled", true, c);

export const disableColumns = (columnNames: string[]) => (c: GroupColumn) =>
  R.includes(c.columnName, columnNames) ? disableColumn(c) : c;
